import React, { useState } from "react";
import { useLanguage } from "../../../../contexts";
import { P, motor } from "../engine";
import { Section } from "../common/SectionCommon";
import "../common/common.scss";
import "./MethodologyGuide.scss";

// Texto fijo del paquete de Sustemia (extraído del prototipo y limpio: solo etiquetas de contenido, sin atributos).
function Tarjeta({ tarjeta }) {
  return <div className="ep-method__card" dangerouslySetInnerHTML={{ __html: tarjeta.html }} />;
}

function Clausula({ c }) {
  const [abierta, setAbierta] = useState(false);
  return (
    <div className="ep-guide__item">
      <button type="button" className="ep-guide__head" aria-expanded={abierta} onClick={() => setAbierta(!abierta)}>
        <span className="ep-mono">{c.n}.</span> <span className="ep-guide__req">{c.t}</span>
      </button>
      {abierta && <ul className="ep-method__items">{c.items.map((x, i) => <li key={i}>{x}</li>)}</ul>}
    </div>
  );
}

// Metodología, normas, glosario y tabla de constantes (hoja 10; hoja 01 filas 9, 52, 132). Contenido igual para todas las plantas.
export function MethodologyGuide() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const { metodologia, alcanceModulo, queNoHace } = motor.textos;
  const [objetivo, ashrae, ...resto] = metodologia;
  return (
    <div className="ep-screen ep-method">
      <h3 className="ep-screen__title">{t("energy_performance_method_title")}</h3>
      <p className="ep-section__note">{t("energy_performance_method_language_note")}</p>
      <Tarjeta tarjeta={objetivo} />
      <Tarjeta tarjeta={alcanceModulo} />
      <Tarjeta tarjeta={queNoHace} />

      <Section title={t("energy_performance_method_iso")}>
        {P.ISO_CLAUSES.map((c) => <Clausula key={c.n} c={c} />)}
      </Section>

      <Tarjeta tarjeta={ashrae} />
      <div className="ep-method__levels">
        {P.ASHRAE_LEVELS.map((l) => <p key={l.n}><strong>{l.n} · {l.t}</strong><br />{l.d}</p>)}
      </div>

      {resto.map((x) => <Tarjeta key={x.titulo} tarjeta={x} />)}

      <Section title={t("energy_performance_constants_title").replace("{n}", P.CONSTANTES_DESC().length)} note={t("energy_performance_constants_note")}>
        <div className="ep-table">
          <table>
            <thead><tr><th>{t("energy_performance_constant")}</th><th>{t("energy_performance_iden_value")}</th><th>{t("energy_performance_unit")}</th><th>{t("energy_performance_constant_controls")}</th><th>{t("energy_performance_constant_backing")}</th></tr></thead>
            <tbody>
              {P.CONSTANTES_DESC().map(([k, v, u, que, resp]) => (
                <tr key={k}><td className="ep-mono">{k}</td><td className="ep-mono">{Array.isArray(v) ? v.join(" / ") : String(v)}</td><td>{u}</td><td>{que}</td><td className="ep-section__note">{resp}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
      </Section>
    </div>
  );
}
